module.exports = __webpack_public_path__ + "media/images/service_logo-21a2f246157dfce173843c3f4db6cdf1.png";